document.querySelectorAll("select[data-scroll-to-next-field-on-change]").forEach(el => {
  el.addEventListener("change", () => {
    const parentRow = el.closest("[data-formie-row]");
    const nextRow = parentRow?.nextElementSibling;
    const target = nextRow && !nextRow.hasAttribute("data-formie-row-hidden") ? nextRow : null;
    if (target) {
      target.scrollIntoView();
    }
  });
});

// Formie 4 clears conditionally hidden fields by deselecting every option (selectedIndex = -1), which leaves
// dropdowns blank when they're revealed. Reselect the default option (e.g. "Select an option") instead
document.addEventListener("formie:field:clear", e => {
  e.target.querySelectorAll("select:not([multiple])").forEach(select => {
    if (select.selectedIndex === -1) {
      const defaultOption = [...select.options].find(option => option.defaultSelected);
      if (defaultOption) {
        defaultOption.selected = true;
      }
    }
  });
});
